// @flow

import * as React from 'react';
import {Cookies} from '@stripe-internal/stripe-cookies';
import {useContext, useMemo} from 'react';
import {useAccount} from 'docs/data';
import {contextStubFunction} from 'docs/util';

export {
  COOKIE_POLICY_URL,
  COOKIE_SETTINGS_PAGE_URL,
} from '@stripe-internal/stripe-cookies';

export type CookieContextType = {
  cookies: Cookies,
  getCookieDomain: () => string,
};

const CookieContext = React.createContext<CookieContextType>({
  cookies: ({}: any),
  getCookieDomain: contextStubFunction('Cookie'),
});

type CookieProviderProps = {|
  children: React.Node,
|};

export const CookieProvider = (props: CookieProviderProps) => {
  const {account} = useAccount();

  const cookies = useMemo(
    () => new Cookies({enforcementMode: account.cookieEnforcementMode}),
    [account.cookieEnforcementMode],
  );

  // This allows setting the cookie to the right domain in the dev environment
  // as well as in production.
  const getCookieDomain = () => {
    const domain = window.location.hostname || 'stripe.com';

    if (domain.match('stripe.com')) {
      return '.stripe.com';
    }
    if (domain.match('dev.stripe.me')) {
      return '.dev.stripe.me';
    }

    return domain;
  };

  const context = {
    cookies,
    getCookieDomain,
  };

  return (
    <CookieContext.Provider value={context}>
      {props.children}
    </CookieContext.Provider>
  );
};

export const useCookies = () => {
  return useContext(CookieContext);
};
